import React from 'react';
import type { ModalComponentProps } from '@components/modals/constants';
import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';

import type { ReportFilterSpec } from '../types';

import { ReportConsole } from './ReportRunPage';

const SCHEDULE_REPORT_KEY = 'schedule';

/**
 * Modal wrapper that embeds the schedule report console, opened from the
 * calendar's print button. The `GlobalModalManager` provides the outer Dialog;
 * this renders the title + close affordance and the chrome-free console, seeded
 * with the calendar's current date window and provider filter (both editable).
 *
 * Opened with `{ maxWidth: 'xl', fullHeight: true }` so the console's internal
 * scroll region fills the sheet.
 */
export const ScheduleReportsModal: React.FC<ModalComponentProps> = ({
  closeModal,
  modalProps,
}) => {
  const initialWindow = modalProps?.initialWindow as
    | { start: string; end: string }
    | undefined;
  const initialFilters = modalProps?.initialFilters as ReportFilterSpec[] | undefined;

  return (
    <>
      <DialogTitle sx={{ pb: 1.5 }}>
        <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            Schedule report
          </Typography>
          <IconButton onClick={closeModal} size="small" aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, p: 0 }}>
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <ReportConsole
            reportKey={SCHEDULE_REPORT_KEY}
            embedded
            initialWindow={initialWindow}
            initialFilters={initialFilters}
          />
        </Box>
      </DialogContent>
    </>
  );
};

export default ScheduleReportsModal;
